import { useTranslation } from "react-i18next";
import {
  useErpTranslationNamespace,
  type UseErpTranslationNamespaceProps,
} from "src/system/useErpTranslationNamespace.ts";

export type UseErpTranslationProps = UseErpTranslationNamespaceProps;
export const useErpTranslation = (props: UseErpTranslationProps) => {
  const ns = useErpTranslationNamespace(props);
  return useTranslation(ns);
};
